import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function CentroHistorico() {
  return <NeighborhoodPageContent slug="centro-historico" />;
}